import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import { StyledButton } from './styles/Button.styles'; // Reusing button
import {
  FileAttachmentWrapper,
  StatusLabel
} from './styles/FileAttachment.styles';

const FileAttachmentControl = ({ control, renderMode }) => {

  const { attributes } = control;

  const buttonStyleProps = {
    ...attributes, 
    fontFamily: attributes.buttonFontFamily,
    fontSize: attributes.buttonFontSize,
    fontWeight: attributes.buttonTextWeight,
    fontStyle: attributes.buttonTextStyle,
    color: attributes.buttonTextColor
  };

  const labelStyleProps = {
    ...attributes,
  };

  return (
    <ObjectWrapper>
      <FileAttachmentWrapper renderMode={renderMode} height={control.height} isButtonLeft={control.buttonLeft}>
        <StyledButton
          styleProps = {buttonStyleProps} 
          isFileAttachment = {true} 
          style = {{ flexShrink: 0, width: 'auto', padding: '0 15px' }}
        >
          {control.buttonLabel}
        </StyledButton>
        <StatusLabel styleProps={labelStyleProps} renderMode={renderMode} >
          {control.statusText}
        </StatusLabel>
      </FileAttachmentWrapper>
    </ObjectWrapper>
  );
}
export default FileAttachmentControl;